export const KEY = 'lib_modal'
